import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowIcon } from '../../assets/icons/down-arrow.svg';

type StaticFilter = {
  label: string;
  isActive: boolean;
  key: string;
};

interface CustomTableStaticFilterProperties {
  header: string;
  column: StaticFilter[];
  onClickFilter: (key: string) => void;
}

/**
 * Table static filter component
 */
function CustomTableStaticFilter(properties: CustomTableStaticFilterProperties) {
  const { header, column, onClickFilter } = properties;
  const { i18n } = useTranslation();
  return (
    <div className="custom-table-static-filter-wrap" dir={i18n.dir()}>
      <div className="static-filter-header">
        <p>{header}</p>
      </div>
      <div className="static-filter-container">
        {column.map((item) => (
          <div
            className="static-filter-each-data"
            role="presentation"
            onClick={() => onClickFilter(item.key)}>
            <p className={`filter-label ${item.isActive && 'selected'}`}>{item.label}</p>
            <span>
              <ArrowIcon />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CustomTableStaticFilter;
